
import * as types from './reports_action_type'
const initialState = {
  gstInvoiceData: [],
  ownChildBranches: [],
  ownChildBranches1: [],
  ownChildUsers: [],
  reportCompany: [],
  franchiseeCompany: [],
  reportCompanyV2: [],
  franchiseeCompanyV2: [],
  franchiseeBranches: [],
  partyBookingFilter: [],
  analysisReportFilter: [],
  dispatchReportFilter: {},
  cargoSettingFilterData: [],
  partyBookingTableData: [],
  branchTransferFilter: {},
  branchReceive: {},
  ownBookingTableData: [],
  branchStockTableData: [],
  franchiseOutstandingTableData: [],
  franchiseOutstandingTableFilterData: [],
  toPayDestinationReportData: [],
  ownBookingDropData: [],
  gstReportFilterData: [],
  gstReportDetailData: [],
  gstReportSummaryData: [],
  dispatchDetailsData: [],
  dispatchDetailsTableData: [],
  dispatchSummaryTableData: [],
  DispatchMemoDetailTableData: [],
  userWiseCollection: [],
  BookingFranchiseeTableData: [],
  analysisDropData: {},
  analysisTableData: {},
  quikViewTableData: {},
  ewayBookingFilter: [],
  ewayBookingTableData: [],
  receivedDropData: {},
  receivedTableData: {},
  goodBalDropData: {},
  goodBalTableData: {},
  reportBranchList: [],
  creditTransactionReportData: [],
  creditUsageReportData: [],
  creditSummaryReportData: {},
  trackingReportFilter: [],
  trackingReportTableData: [],
  deliveryFilterData:[],
  deliveryTableData:[],
  lrPenaltyReportFilterData:[],
  lrPenaltyReportTableData:[],
  cargoUnloadingTableData:[],
  dispatchedVehicleNoData:[],
  partyCreditUsageReportData:[],
  userWithTransRightReportData:[],
  rechargePenaltyReportData:[],
  partyTargetAchivmentReportData:[],
  partyTargetAchivmentFilterData:[],
  partycreditTransReportData: [],
  partyCreditLimitSummaryReportData:[],
  lagguageModificationReportData:[],
  lrDetailsPopupData:[],
  getCargoSettingData:[],
  bookingSummaryReportData:[],
  dispatchResisterFilterData:[],
  dispatchResisterTableData:{},
  dispatchResisterTableVehicleWiseData:{},
  dispatchResisterMemoTableData:[],
  receiptRegisterFilterData:[],
  receiptRegisterReportData: [],
  mpesaTransactionReportTableData: [],
  toPayStatementReportData:[],
  branchStockFilterData:[],
  userWiseCollectionWithDeliveryExpense:[],
}
const reportsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.OWN_AND_CHILD_BRANCHES:
      return { ...state, ownChildBranches: action.data }
    case types.OWN_AND_CHILD_BRANCHES_ONE:
      return { ...state, ownChildBranches1: action.data }
    case types.OWN_AND_CHILD_USERS:
      return { ...state, ownChildUsers: action.data }
    case types.REPORT_COMPANY:
      return { ...state, reportCompany: action.data }
    case types.FRANCHISEE_COMPANY:
      return { ...state, franchiseeCompany: action.data }
      case types.REPORT_COMPANYV2:
        return { ...state, reportCompanyV2: action.data }
      case types.FRANCHISEE_COMPANYV2:
        return { ...state, franchiseeCompanyV2: action.data }
    case types.FRANCHISEE_BRANCH:
      return { ...state, franchiseeBranches: action.data }
    case types.PARTY_BOOKING_FILTER:
      return { ...state, partyBookingFilter: action.data }
    case types.ANALYSIS_FILTER:
      return { ...state, analysisReportFilter: action.data }
    case types.DISPATCH_FILTER:
      return { ...state, dispatchReportFilter: action.data }
    case types.BRANCH_TRANSFER:
      return { ...state, branchTransferFilter: action.data }
    case types.BRANCH_RECEIVE:
      return { ...state, branchReceive: action.data }
    case types.GST_INVOICE:
      return { ...state, gstInvoiceData: action.data }
    case types.OWN_BOOKING_REPORT_DATA:
      return { ...state, ownBookingTableData: action.data }
    case types.BRANCHSTOCK_TABLE_DATA:
      return { ...state, branchStockTableData: action.data }
    case types.FRANCHISE_OUTSTANDING_TABLE_DATA:
      return { ...state, franchiseOutstandingTableData: action.data }
    case types.FRANCHISE_OUTSTANDING_TABLE_FILTER_DATA:
      return { ...state, franchiseOutstandingTableFilterData: action.data }
    case types.TO_PAY_DESTINATION_REPORT_TABLE_DATA:
      return { ...state, toPayDestinationReportData: action.data }
    case types.OWN_BOOKING_REPORT_DROP_DATA:
      return { ...state, ownBookingDropData: action.data }

    case types.GST_REPORT_FILTER_DATA:
      return { ...state, gstReportFilterData: action.data }

    case types.GST_REPORT_DETAIL_DATA:
      return { ...state, gstReportDetailData: action.data }
    case types.GST_REPORT_Summary_DATA:
      return { ...state, gstReportSummaryData: action.data }
    case types.DISPATCH_DETAILS:
      return { ...state, dispatchDetailsData: action.data }
    case types.DISPATCH_DETAILS_DATA:
      return { ...state, dispatchDetailsTableData: action.data }
    // case types.BOOKING_SUMMARY_REPORT_DATA:
    //   return { ...state, bookingSummaryReportData: action.data }
    case types.CHALLAN_WISE_DISPATCH_DATA:
      return { ...state, challanWiseDispatchTableData: action.data }
    case types.DISPATCH_SUMMARY_DATA:
      return { ...state, dispatchSummaryTableData: action.data }
    case types.DISPATCH_MEMODETAIL_DATA:
      return { ...state, DispatchMemoDetailTableData: action.data }
    case types.USER_WISE_COLLECTION:
      return { ...state, userWiseCollection: action.data }
    case types.BRANCH_LIST_CONFIG:
      return { ...state, branchListConfig: action.data }
    case types.FRANCHISEE_TO_OWN:
      return { ...state, franchiseeToOwn: action.data }
    case types.BOOKING_FILTER_DATA:
      return { ...state, bookingFilterData: action.data }
    case types.ANALYSIS_TABLE_DATA:
      return { ...state, analysisTableData: action.data }
    case types.CARGO_SETTING_FILTER:
      return { ...state, cargoSettingFilterData: action.data }
    case types.PARTY_BOOKING_DATA:
      return { ...state, partyBookingTableData: action.data }
    case types.RECEIVED_DROP_DATA:
      return { ...state, receivedDropData: action.data }
    case types.RECEIVED_TABLE_DATA:
      return { ...state, receivedTableData: action.data }
    case types.QUIKVIEW_TABLE_DATA:
      return { ...state, quikViewTableData: action.data }
    case types.USER_WISE_COLLECTION_WITH_DELIVERY_EXPENSE:
      return { ...state, userWiseCollectionWithDeliveryExpense: action.data }
    case types.ON_ACCOUNT_REPORT_DATA:
      return {
        ...state,
        onAccountReportData: action.data,
      }
    case types.REPORT_BRANCH_LIST:
      return {
        ...state,
        reportBranchList: action.data,
      }

    case types.CREDIT_TRANSACTION_DATA:
      return {
        ...state,
        creditTransactionReportData: action.data,
      }
    case types.PARTY_CREDIT_TRANSACTION_DATA:
      return {
        ...state,
        partycreditTransReportData: action.data,
      }
    case types.CREDIT_SUMMARY_DATA:
      return {
        ...state,
        creditSummaryReportData: action.data,
      }
    case types.PARTY_CREDIT_LIMIT_SUMMARY_DATA:
      return {
        ...state,
        partyCreditLimitSummaryReportData: action.data,
      }
    case types.CREDIT_Usage_DATA:
      return {
        ...state,
        creditUsageReportData: action.data,
      }
    case types.PARTY_CREDIT_Usage_DATA:
      return {
        ...state,
        partyCreditUsageReportData: action.data,
      }
    case types.BOOKING_FRANCHISEE_DATA:
      return { ...state, BookingFranchiseeTableData: action.data }
    case types.EWAY_BOOKING_FILTER:
      return { ...state, ewayBookingFilter: action.data }
    case types.EWAY_BOOKING_DATA:
      return { ...state, ewayBookingTableData: action.data }
    case types.GOODBAL_DROP_DATA:
      return { ...state, goodBalDropData: action.data }
    case types.GOODBAL_TABLE_DATA:
      return { ...state, goodBalTableData: action.data }
    case types.TRACKING_REPORT_FILTER:
      return { ...state, trackingReportFilter: action.data }
    case types.TRACKING_REPORT_DATA:
      return { ...state, trackingReportTableData: action.data }
    case types.DELIVERY_FILTER_DATA:
      return { ...state, deliveryFilterData: action.data }
    case types.DELIVERY_TABLE_DATA:
      return { ...state, deliveryTableData: action.data }
    case types.LR_CANCEL_AND_PENALTY_REPORT_FILTER_DATA:
      return { ...state, lrPenaltyReportFilterData: action.data }
    case types.LR_CANCEL_AND_PENALTY_REPORT_TABLE_DATA:
      return { ...state, lrPenaltyReportTableData: action.data }
    case types.CARGO_UNLOADING_TABLE_DATA:
      return { ...state, cargoUnloadingTableData: action.data }
    case types.DISP_VEHICLENO_DATA:
      return { ...state, dispatchedVehicleNoData: action.data }
    case types.USER_WIth_TRANS_RIGHT_REPORT_TABLE_DATA:
      return { ...state, userWithTransRightReportData: action.data }
    case types.RECHAGE_PENALTY_REPORT_TABLE_DATA:
      return { ...state, rechargePenaltyReportData: action.data }
    case types.PARTY_TARGET_ACHIVEMENT_REPORT_TABLE_DATA:
      return { ...state, partyTargetAchivmentReportData: action.data }
    case types.PENALTY_TARGET_ACHIVEMENT_REPORT_FILTER_DATA:
      return { ...state, partyTargetAchivmentFilterData: action.data }
    case types.LUGGAGE_MODIFICATION_REPORT:
      return { ...state, lagguageModificationReportData: action.data }
    case types.LR_DETAILS_FOR_POPUP_V2:
      return { ...state, lrDetailsPopupData: action.data }
    case types.GET_CARGO_SETTING:
      return { ...state, getCargoSettingData: action.data }
    case types.DISPATCH_RESITER_FILTER:
      return { ...state, dispatchResisterFilterData: action.data }
    case types.DISPATCH_RESITER_TABLE_DATA:
      return { ...state, dispatchResisterTableData: {...action.data} }
    case types.DISPATCH_RESITER_TABLE_VEHICLE_WISE_DATA:
      return { ...state, dispatchResisterTableVehicleWiseData: {...action.data} }
    case types.DISPATCH_RESITER_MEMO_TABLE:
      return { ...state, dispatchResisterMemoTableData: action.data }
    case types.RECEIPT_RESITER_FILTER:
      return { ...state, receiptRegisterFilterData: action.data }
    case types.RECEIPT_REGISTER_REPORT_TABLE_DATA:
      return { ...state, receiptRegisterReportData: action.data }
    case types.MPESA_TRANSACTION_REPORT:
      return { ...state, mpesaTransactionReportTableData: action.data }
    case types.TO_PAY_STATEMENT_REPORT:
      return { ...state, toPayStatementReportData: action.data }
    case types.BRANCH_STOCK_FILTER_DATA:
      return { ...state, branchStockFilterData: action.data }
        
    default:
      return state
  }
}
export default reportsReducer